import React, { useState } from "react";
import Mainsection from "./Mainsection";
import Navbar  from "./Navbar";
import Biography from "./Biography"
import Skills from "./Skills";
import Education from "./Education";
import "./App.css";
import Projects from "./Projects";
import Contact from "./Contact";
import Information from "./Information";
import Footer from "./Footer";


const App = ()  => {
  

  return(
    <div className="body  bg-fixed  bg-cover">
      <Navbar/>
      <Mainsection/>
      <Biography/>
      <Skills/>
      <Education/>
      <Projects/>
      <Contact/>
      <Information/>
      <Footer/>
    </div>
  );
}

export default App;
